import React from "react";
import { BsCart4 } from "react-icons/bs";
import { useCart } from "./itemContext";

const CheckoutItems = () => {
    const { cart, setCartItems} = useCart();
    return (
        <div className="checkoutlist">
        <div className="ItemList col-sm-10">
            <p>CHECKOUT ITEM LIST</p>
            <hr />
            {cart && cart.map((item, index) => {
                return (
                    <div key={item.item_Code} className="item-separator">
                        {`${index + 1}. ${item.item_Code} - ${item.item_Name} * ${item.quantity?item.quantity:0}`}
                    </div>
                );
            })}
        </div>
        </div>
    );
};

export default CheckoutItems;